export default __webpack_public_path__ + "static/media/support_platform_drainage3.0b7fa7ee.png";